import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  getSchedulingNotificationApi,
  getSchedulingNotificationCountApi,
  postSchedulingNotificationClearApi,
} from "@/apis/notificationApi";

import type {
  GetSchedulingNotificationCountPayloadType,
  GetSchedulingNotificationPayloadType,
  postSchedulingNotificationClearPayloadType,
} from "@/commonTypes/notificationType";

export const getSchedulingNotificationAction = createAsyncThunk(
  `notification/scheduling`,
  async (data: GetSchedulingNotificationPayloadType) => {
    const response = await getSchedulingNotificationApi(data);
    return response.data;
  }
);

export const getSchedulingNotificationCountAction = createAsyncThunk(
  `notificationCount/scheduling`,
  async (data: GetSchedulingNotificationCountPayloadType) => {
    const response = await getSchedulingNotificationCountApi(data);
    return response.data;
  }
);

export const postSchedulingNotificationClearAction = createAsyncThunk(
  `notification/clearOrMarkAll`,
  async (data: postSchedulingNotificationClearPayloadType) => {
    const response = await postSchedulingNotificationClearApi(data);
    return response.data;
  }
);
